import { IToggleTrigger } from '@/hooks/useToggle';
import { Image } from '@/components/Image';
import CountryModal from '../CountryModal';
import useLocale from '@/hooks/useLocale';

interface IProps {
  countryModal: IToggleTrigger;
  onClick?: () => void;
}

const data = { en: 'English', zh: '简体', ja: '日本語', es: 'Español' };

export function GNB({ onClick, countryModal }: IProps) {
  const { locale } = useLocale();

  return (
    <>
      <div className="flex flex-row justify-between px-5 items-center w-[calc(100%-260px)] border-b border-[#f5f5f5] h-[75px] fixed top-0 bg-white z-[8]">
        <div />
        <div className="h-full flex items-center gap-2">
          <div className="py-[10px] px-3 bg-[#F8F8F8] rounded-full items-center flex gap-2" onClick={countryModal.toggle}>
            <Image alt={'global-icon'} width={24} height={24} src={'/icons/global.svg'} />
            <span className="text-[14px] font-medium">{data[locale]}</span>
            <Image
              alt={'chevron-down'}
              width={16}
              height={16}
              src={'/icons/chevron-down.svg'}
              className={`${countryModal.isShowing ? 'rotate-180' : 'rotate-0'} `}
            />
          </div>
          <div className="w-[44px] h-[44px] rounded-full flex items-center justify-center bg-[#F8F8F8]">
            <Image alt={'line-menu'} width={24} height={24} src={'/icons/line-menu.svg'} onClick={onClick} />
          </div>
        </div>
      </div>

      {countryModal.isShowing && <CountryModal onCountryClick={countryModal.close} />}
    </>
  );
}
